import { dismissToast, toasts } from '../state';
import { Icon } from './Icon';

export function ToastStack() {
  return (
    <div class="toasts" role="status" aria-live="polite">
      {toasts.value.map((t) => (
        <div key={t.id} class={`toast toast-${t.kind}`}>
          <span class="toast-mark" aria-hidden="true">
            {t.kind === 'good' ? '✓' : t.kind === 'bad' ? '!' : 'i'}
          </span>
          <span class="toast-text">{t.text}</span>
          <button type="button" class="toast-close" aria-label="Dismiss" onClick={() => dismissToast(t.id)}>
            <Icon name="close" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
